import useWorldStore from "../store/worldStore";
import { executeTask } from "../services/taskExecutor";
import { findTaskByIdentity } from "./taskIdentity";
import { getErrorMessage, showErrorToast } from "../../../lib/toast-store";

export async function runAgentQueue(agentId) {
  const initialState = useWorldStore.getState();
  if (initialState.activeTasks[agentId]?.status === "running") return;

  while (true) {
    const current = useWorldStore.getState();
    if (!current.openclawConnected) break;
    const queue = current.taskQueues[agentId] || [];
    if (queue.length === 0) break;

    current.startNextTask(agentId);
    const task = useWorldStore.getState().activeTasks[agentId];
    if (!task) break;

    try {
      await executeTask(agentId, task.instruction);
      const completedTask = findTaskByIdentity(
        useWorldStore.getState().completedTasks,
        task,
        agentId
      );
      if (completedTask) {
        useWorldStore.getState().openResultModal(completedTask);
      }
    } catch (error) {
      const failedTask = findTaskByIdentity(
        useWorldStore.getState().completedTasks,
        task,
        agentId
      );
      if (failedTask) {
        useWorldStore.getState().openResultModal(failedTask);
      }
      const agent = useWorldStore.getState().agents.find((entry) => entry.id === agentId);
      const detail = getErrorMessage(error, "Task failed");
      showErrorToast({
        id: `world-task-failed-${agentId}-${task.id || Date.now()}`,
        message: `${agent?.name || "Agent"} task failed: ${detail}`,
      });
      throw error;
    }
  }

  setTimeout(() => useWorldStore.getState().clearAgentIndicator(agentId), 3000);
}

export function queueTaskAndKickoff(agent, instruction, label) {
  const store = useWorldStore.getState();
  const agentId = agent?.id;
  if (!agentId) return;

  store.enqueueTask(agentId, instruction, label);
  store.setAgentIndicator(agentId, { type: "task", pulsing: true });
  store.addTaskToast(`${agent.name || "Agent"} → ${label}`, agent.color);

  setTimeout(() => {
    void runAgentQueue(agentId).catch((error) => {
      console.warn("[task-queue-actions] task failed", agentId, error);
    });
  }, 100);
}
